import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import { Fade } from "react-awesome-reveal";
import { Link } from 'react-router-dom'
import icon from '../../images/icon/dollar-icon.svg'
import picon from '../../images/icon/pricing-icon01.svg'
import picon2 from '../../images/icon/pricing-icon02.svg'
import picon3 from '../../images/icon/pricing-icon03.svg'
import check from '../../images/icon/check-icon.svg'
import cross from '../../images/icon/cross-icon.svg'
import Bg from '../../images/bg/page_bg01.jpg'


const PricingSection = () => {
    const [activeTab, setActiveTab] = useState('1');

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="pricing pt-30 pb-130">
                
            <section className="page-title pt-200 pos-rel bg_img" style={{ backgroundImage: `url(${Bg})` }}>
            <div className="container">
                <div className="sec-title--two text-center mb-60">

                    <Fade direction='down' triggerOnce={'false'} duration={1200} delay={9}>
                        <div>
                            <h2 className="title wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">
                                Take control of your ticketing and membership with easy to understand pricing.
                            </h2>
                        </div>
                    </Fade>
                </div>

                <div className="xb-pricing-nav-wrap text-center mb-110">
                    <Nav tabs className="xb-pricing-nav ul_li_center nav nav-tabs" id="myTab" role="tablist">
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '1' })}
                                onClick={() => toggle('1')}
                            >
                                Billed yearly <span>Discounts Available</span>
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '2' })}
                                onClick={() => toggle('2')}
                            >
                                Billed monthly
                            </NavLink>
                        </NavItem>
                    </Nav>
                </div>

                <div className="pg-pricing_content">
                    <TabContent activeTab={activeTab} id="myTabContent">
                        {/* Yearly Tab Content */}
                        <TabPane tabId="1">
                            <Row className="mt-none-30">
                                {/* Pricing Plan 1 */}
                                <Col lg="4" className="mt-30">
                                    <div className="pg-pricing-item pos-rel">
                                        <div className="xb-item--inner o-hidden pos-rel">
                                            <div className="xb-item--holder ul_li">
                                                <div className="xb-item--icon">
                                                    <img src={picon} alt="" />
                                                </div>
                                                <div className="xb-item--right">
                                                    <h3 className="xb-item--title">Basic</h3>
                                                    <span className="xb-item--text">For businesses starting.</span>
                                                </div>
                                            </div>
                                            <div className="xb-item--price">
                                                <h2 className="xb-item--number">£200</h2>
                                                <span className="xb-item--time">Per Year</span>
                                            </div>
                                            <div className="xb-item--line"></div>
                                            <h4 className="xb-item--feature">Features</h4>
                                            <ul className="xb-item--list list-unstyled">
                                                <li><img src={check} alt="" /> Membership Management Platform</li>
                                                <li><img src={check} alt="" /> Up to 100 Members</li>
                                                <li><img src={check} alt="" /> Issue up to 500 Tickets</li>
                                                <li><img src={check} alt="" /> Reporting and Analytics</li>
                                                <li><img src={check} alt="" /> 1.5% Commission per Transaction</li>
                                                <li className="deactive"><img src={cross} alt="" /> Events Listed on Marketplace</li>
                                            </ul>
                                            <div className="pg-det-btn">
                                                <Link onClick={ClickHandler} to="https://algr.io/register?plan=basic" className="cp-btn">Choose your plan</Link>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                {/* Pricing Plan 2 */}
                                <Col lg="4" className="mt-30">
                                    <div className="pg-pricing-item active pos-rel">
                                        <span className="xb-item--top-text">Most popular ✨</span>
                                        <div className="xb-item--inner o-hidden pos-rel">
                                            <div className="xb-item--holder ul_li">
                                                <div className="xb-item--icon">
                                                    <img src={picon2} alt="" />
                                                </div>
                                                <div className="xb-item--right">
                                                    <h3 className="xb-item--title">Standard</h3>
                                                    <span className="xb-item--text">For businesses with more traffic.</span>
                                                </div>
                                            </div>
                                            <div className="xb-item--price">
                                                <h2 className="xb-item--number">£500</h2>
                                                <span className="xb-item--time">Per Year</span>
                                            </div>
                                            <div className="xb-item--line"></div>
                                            <h4 className="xb-item--feature">Features</h4>
                                            <ul className="xb-item--list list-unstyled">
                                                <li><img src={check} alt="" /> Membership Management Platform</li>
                                                <li><img src={check} alt="" /> Up to 500 Members</li>
                                                <li><img src={check} alt="" /> Issue up to 2500 Tickets</li>
                                                <li><img src={check} alt="" /> Reporting and Analytics</li>
                                                <li><img src={check} alt="" /> 1.2% Commission per Transaction</li>
                                                <li><img src={check} alt="" /> Events Listed on Marketplace</li>
                                            </ul>
                                            <div className="pg-det-btn">
                                                <Link onClick={ClickHandler} to="https://algr.io/register?plan=standard" className="cp-btn">Choose your plan</Link>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                {/* Pricing Plan 3 */}
                                <Col lg="4" className="mt-30">
                                    <div className="pg-pricing-item pos-rel">
                                        <div className="xb-item--inner o-hidden pos-rel">
                                            <div className="xb-item--holder ul_li">
                                                <div className="xb-item--icon">
                                                    <img src={picon3} alt="" />
                                                </div>
                                                <div className="xb-item--right">
                                                    <h3 className="xb-item--title">Premium</h3>
                                                    <span className="xb-item--text">For large enterprises .</span>
                                                </div>
                                            </div>
                                            <div className="xb-item--price">
                                                <h2 className="xb-item--number">£1500</h2>
                                                <span className="xb-item--time">Per Year</span>
                                            </div>
                                            <div className="xb-item--line"></div>
                                            <h4 className="xb-item--feature">Features</h4>
                                            <ul className="xb-item--list list-unstyled">
                                                <li><img src={check} alt="" /> Membership Management Platform</li>
                                                <li><img src={check} alt="" /> Unlimited Members</li>
                                                <li><img src={check} alt="" /> Issue Unlimited Tickets</li>
                                                <li><img src={check} alt="" /> Account Manager for Reporting</li>
                                                <li><img src={check} alt="" /> Dynamic Commission Rate</li>
                                                <li><img src={check} alt="" /> Events Listed on Marketplace</li>
                                            </ul>
                                            <div className="pg-det-btn">
                                                <Link onClick={ClickHandler} to="/contact" className="cp-btn">Choose your plan</Link>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>

                        {/* Monthly Tab Content */}
                        <TabPane tabId="2">
                            <Row className="mt-none-30">
                                {/* Pricing Plan 1 (Monthly) */}
                                <Col lg="4" className="mt-30">
                                    <div className="pg-pricing-item pos-rel">
                                        <div className="xb-item--inner o-hidden pos-rel">
                                            <div className="xb-item--holder ul_li">
                                                <div className="xb-item--icon">
                                                    <img src={picon} alt="" />
                                                </div>
                                                <div className="xb-item--right">
                                                    <h3 className="xb-item--title">Basic</h3>
                                                    <span className="xb-item--text">For businesses starting.</span>
                                                </div>
                                            </div>
                                            <div className="xb-item--price">
                                                <h2 className="xb-item--number">£25</h2>
                                                <span className="xb-item--time">Per Month</span>
                                            </div>
                                            <div className="xb-item--line"></div>
                                            <h4 className="xb-item--feature">Features</h4>
                                            <ul className="xb-item--list list-unstyled">
                                                <li><img src={check} alt="" /> Membership Management Platform</li>
                                                <li><img src={check} alt="" /> Up to 100 Members</li>
                                                <li><img src={check} alt="" /> Issue up to 500 Tickets</li>
                                                <li><img src={check} alt="" /> Reporting and Analytics</li>
                                                <li><img src={check} alt="" /> 1.5% Commission per Transaction</li>
                                                <li className="deactive"><img src={cross} alt="" /> Events Listed on Marketplace</li>
                                            </ul>
                                            <div className="pg-det-btn">
                                                <Link onClick={ClickHandler} to="https://algr.io/register?plan=basic" className="cp-btn">Choose your plan</Link>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                {/* Pricing Plan 2 (Monthly) */}
                                <Col lg="4" className="mt-30">
                                    <div className="pg-pricing-item active pos-rel">
                                        <span className="xb-item--top-text">Most popular ✨</span>
                                        <div className="xb-item--inner o-hidden pos-rel">
                                            <div className="xb-item--holder ul_li">
                                                <div className="xb-item--icon">
                                                    <img src={picon2} alt="" />
                                                </div>
                                                <div className="xb-item--right">
                                                    <h3 className="xb-item--title">Standard</h3>
                                                    <span className="xb-item--text">For businesses with more traffic.</span>
                                                </div>
                                            </div>
                                            <div className="xb-item--price">
                                                <h2 className="xb-item--number">£60</h2>
                                                <span className="xb-item--time">Per Month</span>
                                            </div>
                                            <div className="xb-item--line"></div>
                                            <h4 className="xb-item--feature">Features</h4>
                                            <ul className="xb-item--list list-unstyled">
                                                <li><img src={check} alt="" /> Membership Management Platform</li>
                                                <li><img src={check} alt="" /> Up to 500 Members</li>
                                                <li><img src={check} alt="" /> Issue up to 2500 Tickets</li>
                                                <li><img src={check} alt="" /> Reporting and Analytics</li>
                                                <li><img src={check} alt="" /> 1.2% Commission per Transaction</li>
                                                <li><img src={check} alt="" /> Events Listed on Marketplace</li>
                                            </ul>
                                            <div className="pg-det-btn">
                                                <Link onClick={ClickHandler} to="https://algr.io/register?plan=standard" className="cp-btn">Choose your plan</Link>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                {/* Pricing Plan 3 (Monthly) */}
                                <Col lg="4" className="mt-30">
                                    <div className="pg-pricing-item pos-rel">
                                        <div className="xb-item--inner o-hidden pos-rel">
                                            <div className="xb-item--holder ul_li">
                                                <div className="xb-item--icon">
                                                    <img src={picon3} alt="" />
                                                </div>
                                                <div className="xb-item--right">
                                                    <h3 className="xb-item--title">Premium</h3>
                                                    <span className="xb-item--text">For large enterprises .</span>
                                                </div>
                                            </div>
                                            <div className="xb-item--price">
                                                <h2 className="xb-item--number">£180</h2>
                                                <span className="xb-item--time">Per Month</span>
                                            </div>
                                            <div className="xb-item--line"></div>
                                            <h4 className="xb-item--feature">Features</h4>
                                            <ul className="xb-item--list list-unstyled">
                                                <li><img src={check} alt="" /> Membership Management Platform</li>
                                                <li><img src={check} alt="" /> Unlimited Members</li>
                                                <li><img src={check} alt="" /> Issue Unlimited Tickets</li>
                                                <li><img src={check} alt="" /> Account Manager for Reporting</li>
                                                <li><img src={check} alt="" /> Dynamic Commission Rate</li>
                                                <li><img src={check} alt="" /> Events Listed on Marketplace</li>
                                            </ul>
                                            <div className="pg-det-btn">
                                                <Link onClick={ClickHandler} to="/contact" className="cp-btn">Choose your plan</Link>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>
                    </TabContent>
                </div>
            </div>
            </section>
        </section>
    );
};

export default PricingSection;
